import axiosInstance from './index';  // 导入你之前创建的axios实例

// 访问量
export async function getVisitCount() {
  try {
      const response = await axiosInstance.get('/visit/count');
      // 假设验证码是以图片形式返回的，你可以返回图片的URL或者直接处理返回的数据
      // console.log(response.data); // 这里假设返回的数据是图片内容
      return response.data;
  } catch (error) {
      console.error('获取验证码图片失败:', error);
      throw error; // 如果有错误，抛出错误
  }
}

// 一级列表接口
export async function getClassify() {
  try {
      const response = await axiosInstance.get('/category/selectAllFirstCategory');
      // 假设验证码是以图片形式返回的，你可以返回图片的URL或者直接处理返回的数据
      // console.log(response.data); // 这里假设返回的数据是图片内容
      return response.data;
  } catch (error) {
      console.error('获取验证码图片失败:', error);
      throw error; // 如果有错误，抛出错误
  }
}

// 获取验证码图片
export async function getCaptchaImage() {
    try {
        const response = await axiosInstance.get('/captchaImage');
        // 假设验证码是以图片形式返回的，你可以返回图片的URL或者直接处理返回的数据
        // console.log(response.data); // 这里假设返回的数据是图片内容
        return response.data;
    } catch (error) {
        console.error('获取验证码图片失败:', error);
        throw error; // 如果有错误，抛出错误
    }
}

export async function getClassifyByCode(code) {
  try {
      // 使用params传递get请求参数
      const response = await axiosInstance.get('/category/selectCategoryByCode', {
          params: {
              code: code  // 传递code参数
          }
      });
      return response.data;
  } catch (error) {
      console.error('根据code获取分类失败:', error);
      throw error;
  }
}

// 提交留言
export async function submitForm({ name, phone, email, company, requirements, captcha, uuid }) {
  try {
      // 构造请求的 Query 参数和 Body 参数
      const queryParams = {
          name,
          phone,
          email,
          company,
          requirements,
          captcha,
          uuid
      };

      // 请求体内容 (Body 参数)
      const requestBody = {
          name: name || '',
          phone: phone || '',
          email: email || '',
          company: company || '',
          requirements: requirements || '',
          captcha: captcha || '',
          uuid: uuid || ''
      };

      // 发送 POST 请求
      const response = await axiosInstance.post('/user/message/saveMessage', requestBody, {
          params: queryParams  // 通过 `params` 传递 Query 参数
      });

      // 返回响应的数据
      return response.data;
  } catch (error) {
      console.error('表单提交失败:', error);
      throw error; // 如果有错误，抛出错误
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js